import React, { useEffect, useState } from 'react'
import { Container, Row, Col,Table, Button, Modal } from 'react-bootstrap'
import { axiosOpen } from "../../../../api/axios.js"
import { useNavigate } from 'react-router-dom';

export default function ListCustomPrompts() {
    const navigate = useNavigate();
    const [prompts, setPrompts] = useState([]);
    const userID = JSON.parse(localStorage.userID);
    const [show, setShow] = useState(false);
    const [selectedPrompt, setSelectedPrompt] = useState({});

    function handleModal() {
        setShow(show => !show);
    }

    function handleView(prompt) {
        handleModal();
        setSelectedPrompt(prompt);
    }

    function handleEdit(promptID) {
        navigate(`/customPrompts/add/${promptID}`);
    }

    function handleAdd() {
        navigate(`/customPrompts/add/`);
    }


    async function getCustomPrompts() {
        // call api to get custom prompts
        const { data } = await axiosOpen.get(`gpt/allprompts/${userID}`);
        const priorityOrder = ["amazon", "target", "walmart"];
        setPrompts(data.prompts.sort((a, b) => priorityOrder.indexOf(a.platform) - priorityOrder.indexOf(b.platform)));
    }

    useEffect(() => {
        getCustomPrompts();
    }, []);
    return (
        <Container className='content-container'>
            <Row>
                <Col className='text-right mb-2'>
                    <Button className="font-size-secondary" onClick={handleAdd}>
                        Add Custom Prompt
                    </Button>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Modal show={show} onHide={handleModal}>
                        <Modal.Header closeButton>
                        <Modal.Title>Prompts</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Container>
                                <Row>
                                    <Col sm="12" xl="3">
                                        <h5>Platform:</h5>
                                    </Col>
                                    <Col>
                                        <p>{selectedPrompt.platform}</p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="12" xl="3">
                                        <h5>Type:</h5>
                                    </Col>
                                    <Col>
                                        <p>{selectedPrompt.type}</p>
                                    </Col>
                                </Row>
                                <Row>

                                </Row>
                                <Row>
                                    <Col sm="12" xl="3">
                                        <h5>Prompts:</h5>
                                    </Col>
                                    <Col>
                                        <p>{selectedPrompt.prompt}</p>
                                    </Col>
                                </Row>
                            </Container>
                        </Modal.Body>
                    </Modal>
                </Col>
            </Row>
            <Row>
                <Col>
                <Table striped hover responsive className="users-prompts-table m-0">
                    <thead>
                    <tr>
                        <th>Platform</th>
                        <th>Prompt</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {prompts.length > 0 &&
                        prompts.map((prompt) => (
                        <tr key={prompt._id}>
                            <td>{prompt.platform}</td>
                            <td>{`${prompt.prompt.length > 30 ? prompt.prompt.slice(0,30) + '...' : prompt.prompt}`}</td>
                            <td className="d-flex justify-content-center gap-3">
                                <Button className="font-size-secondary" onClick={() =>  handleView(prompt)}>
                                    VIEW
                                </Button>
                                <Button className="font-size-secondary" onClick={() => handleEdit(prompt._id)}>
                                    EDIT
                                </Button>
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </Table>
                </Col>
            </Row>
        </Container>
    )
}
